export default "__VITE_ASSET__DqNTamAa__"